import React from "react";
import "./Styles/storecard.css";
import BasicCard from './BasicCard';
import InfiniteScroll from 'react-infinite-scroll-component';
import ProductCard from "./ProductCard";


export default function StoreCard({results, fetchData, hasMore}) {
    let displayResults = [];

    results.map((x, index)=>{
        displayResults.push(
            <div key={'productResult'+index} className="storecard-container">
                <ProductCard product={x}/>
            </div>
        )
    })

    const loadingBadge =(<>
        <p className="loadingBadge">
            Chargement...
        </p>
    </>)

const finishedBadge = (<>
    <p className="finishedBadge">
        {results.length} résultat(s)
    </p>
</>)
      
    
    return (
        <>
        <InfiniteScroll
        dataLength={results.length} //This is important field to render the next data
        next={fetchData}
        hasMore={hasMore}
        loader={loadingBadge}
        endMessage={finishedBadge}
        >
            <div className="storecard">
                {displayResults}
            </div>
        </InfiniteScroll>

        </>

    )
}